module.exports = __webpack_public_path__ + "static/media/dotted-square.4da1fa69.svg";